/**
 * Drift Actions
 * @param {Function} updateChatSidebar - Toggle Chat Sidebar in Chat.vue
 * @param {Function} updateChatNewMessage - Update message in Chat.vue
 * @param {Object} drift - Drift object from window
 */
export default function driftConfig(
  updateChatSidebar,
  updateChatNewMessage,
  drift = window.drift,
) {
  const height = '60%';
  const config = {
    locale: 'en-US',
    backgroundColor: '#12849a',
  };

  drift.on('sidebarOpen', () => {
    setTimeout(() => {
      const driftWidget = document.getElementsByClassName('drift-widget-chat-layout');
      if (driftWidget && driftWidget[0]) {
        driftWidget[0].style.height = height;
      }
    }, 1);

    updateChatSidebar(true);
  });

  drift.on('sidebarClose', () => {
    updateChatSidebar(false);
  });

  drift.on('message', (messageObject) => {
    const driftWidgetOpen = document.getElementsByClassName('drift-chat-open');

    if (!driftWidgetOpen.length) {
      updateChatNewMessage(messageObject);
    }
  });

  drift.config(config);
}
